import { CommonApi } from "api/common.api";
import React from "react";

const useGetCititesHook = () => {
  const [city, setCity] = React.useState("");
  const [citiesState, setCitiesState] = React.useState<
    Array<{
      label: string;
      value: any;
    }>
  >([]);
  const debounceRef = React.useRef<NodeJS.Timeout>();

  const getCities = async (city: string) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      const citiesList = await CommonApi.getDbCities({
        city,
      });

      setCitiesState(
        citiesList.data.result.map((accomodation) => ({
          label: `${accomodation.city}, ${accomodation.country}`,
          value: accomodation.id,
        }))
      );
    }, 500);
  };

  React.useEffect(() => {
    getCities(city);
  }, [city]);

  return { citiesState, getCities, city, setCity };
};

export default useGetCititesHook;
